import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';

import { createTheme } from '@mui/material';

import { useDispatch, useSelector } from 'react-redux';
import { getDisplayName } from '../../util/deviceHelpers';
import CustomTableContainer from '../Common/Table/CustomTableContainer';
import { HeaderDataTypes, USER_ALERT_STATUS } from '../../util/constants';
import { getFormattedTimeString } from '../../util/time';

import NewAlert from '@material-ui/icons/Warning';
import AcknowledgedAlert from '@material-ui/icons/Visibility';
import ResolvedAlert from '@material-ui/icons/CheckCircle';

import { Button, FormControlLabel, Grid, Switch, Tooltip } from '@material-ui/core';
import { fetchUserAlerts, updateUserAlert } from '../../actions/alertActions';
import AlertSettingModal from './alertSettingModal';
import AckAllAlertsModal from './ackAllModal';
import ResolveAllAlertsModal from './resolveAllModal';

const theme_bp = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 680,
      md: 850,
      lg: 1200,
      xl: 1536,
    },
  },
});

const useStyles = makeStyles({
  grid: {
    marginBottom: 10
  }
});

const defaultHeaders = [
  {
    id: 'status_icon',
    type: HeaderDataTypes.ELEMENT,
    label: 'Alert Status',
    display: true
  },
  {
    id: 'status_text',
    type: HeaderDataTypes.STRING,
    label: 'Alert Status Text',
    display: false
  },
  {
    id: 'alert_type',
    type: HeaderDataTypes.STRING,
    label: 'Alert Type',
    display: false
  },
  {
    id: 'alert_summary',
    type: HeaderDataTypes.STRING,
    label: 'Alert Title',
    display: true
  },
  {
    id: 'alert_key',
    type: HeaderDataTypes.STRING,
    label: 'Associated Domain',
    display: true
  },
  {
    id: 'associated_id',
    type: HeaderDataTypes.STRING,
    label: 'Associated ID',
    display: true
  },
  {
    id: 'created_at',
    type: HeaderDataTypes.DATE,
    label: 'Created At',
    display: true
  },
  {
    id: 'action',
    type: HeaderDataTypes.ELEMENT,
    label: 'Action',
    display: true
  }
];



export default function AlertsTable(props) {
  const [processedAlerts, setProcessedAlerts] = useState([]);
  const [showResolved, setShowResolved] = useState(false);
  const alerts = useSelector((state) => state.alerts.alerts);
  const alertSettings = useSelector((state) => state.alerts.alertSettings);
  const groups = useSelector((state) => state.group.groupData);
  const dispatch = useDispatch();
  const classes = useStyles();

  const setAlertStatus = async (id, status) => {
    await updateUserAlert(id, status);
    dispatch(fetchUserAlerts());
  }

  const getAlertIcon = (status) => {
    switch (status) {
      case (USER_ALERT_STATUS.NEW): return (<Tooltip title="New Alert"><NewAlert style={{ color: "red" }} /></Tooltip>);
      case (USER_ALERT_STATUS.ACKNOWLEDGED): return (<Tooltip title="Acknowledged Alert"><AcknowledgedAlert /></Tooltip>);
      case (USER_ALERT_STATUS.RESOLVED): return (<Tooltip title="Resolved Alert"><ResolvedAlert style={{ color: "green" }} /></Tooltip>);
      default: return;
    }
  }

  const getActionElement = (id, status) => {
    switch (status) {
      case (USER_ALERT_STATUS.NEW): return (<Button variant="outlined" color="primary" onClick={() => setAlertStatus(id, USER_ALERT_STATUS.ACKNOWLEDGED)}>Acknowledge</Button>);
      case (USER_ALERT_STATUS.ACKNOWLEDGED): return (<Button variant="outlined" color="primary" onClick={() => setAlertStatus(id, USER_ALERT_STATUS.RESOLVED)}>Resolve</Button>);
      case (USER_ALERT_STATUS.RESOLVED): return (<Button variant="outlined" color="primary" disabled>Resolved</Button>);
      default: return;
    }
  }

  useEffect(() => {
    if (alerts) {
      setProcessedAlerts(
        alerts
        .filter((alert) => showResolved || alert.status !== USER_ALERT_STATUS.RESOLVED)
        .map((alert, index) => {
          return {
            id: index,
            alert,
            alert_type: alert.alert_type,
            alert_summary: alert.summary,
            alert_key: alert.alert_key,
            associated_id: alert.associated_id.toString(),
            created_at: alert.created_at,
            status_text: alert.status,
            status_icon: { element: getAlertIcon(alert.status), present: true },
            action: { element: getActionElement(alert.id, alert.status), present: true },
            no_click: true
          }
        })
      );
    }

  }, [alerts, showResolved]);

  return (
    <>
      <Grid container direction="row-reverse" justifyContent="flex-end" className={classes.grid}>
        <FormControlLabel checked={showResolved} onChange={() => setShowResolved(!showResolved)} control={<Switch />} label="Show Resolved" />
        <ResolveAllAlertsModal />
        <AckAllAlertsModal />
      </Grid>
      <CustomTableContainer
        defaultOrder="desc"
        defaultOrderHeader="created_at"
        headers={defaultHeaders}
        rowData={processedAlerts}
        paginationOptions={[5, 10, 25, 50, 100]}
        defaultPaginationOption={25}
        clickAction={() => { }}
        swipeable={true}
        insightsTable={false}
        AdditionalToolbar={<AlertSettingModal groups={groups} settings={alertSettings?.settings} groupSettings={alertSettings?.groupSettings}/>}
        UnsavedChangesSnackbar={false}
        
      />
    </>
  );
}
